<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container xl">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">ライセンスの購入の完了</span>
        </div>
        <div class="popup-content">
          <p class="purchase-description txt">ライセンス購入が完了しました。<br>ご購入いただいたライセンスは本日からご利用いただけます。<br><router-link to="/pc/contract-assign-license" class="txt-blue" role="button">ライセンス管理</router-link>から、ご利用ユーザにライセンスの付与を行ってください。</p>
          <div class="purchase-info">
            <div class="purchase-info-content">
              <dl class="purchase-info-list">
                <dt>申込内容</dt>
                <dd>ライセンスの購入</dd>
                <dt>申込日</dt>
                <dd>{{formatDateKanji(paymentList.created)}}</dd>
                <dt>合計金額</dt>
                <dd>{{breakComma(paymentList.total_fee)}}円（税込）</dd>
                <dt>支払い方法</dt>
                <dd>{{paymentList.payment}}</dd>
              </dl>
            </div>
            <p class="purchase-info-id txt-sup">申込No.{{applicationNo}}</p>
          </div>
          <div v-for="(_pack, index) in paymentList.package_lists" :key="'_pack_' + index" class="purchase-detail">
            <div class="purchase-detail-heading">
              <h2 class="hdg03">{{_pack.package_name}}</h2>
              <p class="purchase-detail-heading-sub"><span>ご請求金額</span>合計<strong>{{breakComma(_pack.sub_total_fee)}}</strong>円（税込）</p>
              <p class="purchase-detail-heading-text">お申し込みいただいたライセンスは、本日から{{formatDateKanji(_pack.period_end)}} までご利用いただけます。</p>
            </div>
            <PurchaseTable :pack="_pack"/>
          </div>
          <div class="purchase-submit">
            <div class="button purchase-submit-button">
              <a @click="close" role="button" class="btn">サービス管理へ</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { ServiceLicensePurchaseComplete } from '@/logic/contract/ServiceLicensePurchaseComplete'
import PurchaseTable from '@/components/pc/partial/contract/PurchaseTable.vue'

export default defineComponent({
  name: 'PCServiceLicensePurchaseComplete',
  components: {
    PurchaseTable
  },
  setup (props, context) {
    return { ...ServiceLicensePurchaseComplete(props, context) }
  }
})
</script>

<style lang="scss" scoped>
.popup-wrapper{
  .popup-container{
    .popup-title{
      padding: 26px 116px 25px 40px;
      .hdg02{
        margin-right: 70px;
      }
    }
  }
  .popup-content{
    padding: 40px;
    .purchase-detail:first-child{
      margin-top: 0;
    }
  }
  .popup-heading{
    background: $color-bg-paper;
    padding: 38px 40px 46px;
    &-text{
      font-size: 16px;
      line-height: 1.625;
      font-weight: bold;
      color: $color-content;
      span{
        color: $color-hdg;
        margin-right: 25px;
      }
      strong{
        font-size: 32px;
        color: $color-hdg;
        margin: 0 10px;
      }
    }
  }
}
.purchase{
  &-info{
    display: table;
    width: 100%;
    table-layout: fixed;
    &-content{
      display: table-cell;
      vertical-align: top;
      width: 60%;
    }
    &-list{
      dt{
        display: inline-block;
        width: 100px;
        font-weight: bold;
        margin-bottom: 8px;
        color: $color-hdg;
      }
      dd{
        display: inline-block;
        width: calc(100% - 100px);
        margin-bottom: 8px;
        color: $color-content;
      }
    }
    &-id{
      display: table-cell;
      vertical-align: top;
      width: 40%;
      text-align: right;
      line-height: 1;
    }
  }
  &-detail{
    margin-top: 32px;
    border-radius: 4px;
    border: 1px solid $color-line;
    & + .purchase-detail{
      margin-top: 48px;
    }
    &-heading{
      background: $color-bg-paper;
      padding: 32px 40px 36px;
      &-sub{
        font-size: 16px;
        line-height: 1.625;
        margin-top: 8px;
        color: $color-content;
        span{
          font-weight: bold;
          margin-right: 25px;
          color: $color-hdg;
        }
        strong{
          font-size: 24px;
          font-weight: bold;
          margin: 0 10px;
          color: $color-hdg;
        }
      }
      &-text{
        font-size: 16px;
        line-height: 1.625;
        margin-top: 5px;
        color: $color-content;
      }
      .hdg03{
        margin-bottom: 0;
      }
    }
    &-content{
      padding: 40px;
      .hdg04{
        margin: 44px 0 20px;
      }
    }
    &-table{
      .tbl{
        thead{
          th{
            background: $color-bg-paper;
            border-bottom: 1px solid $color-line;
            padding: 22px 20px 15px;
            font-weight: normal;
            color: $color-content;
          }
        }
        tbody{
          th,td{
            padding: 26px 20px 22px;
          }
          th{
            font-weight: bold;
            color: $color-hdg;
            text-align: left;
            border-top: 1px solid $color-line;
          }
          td{
            color: $color-content;
          }
        }
      }
    }
  }
  &-subtitle{
    margin: 42px 0 28px;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(112,112,112,0.2);
  }
  &-submit{
    text-align: center;
    margin-top: 25px;
    &-button{
      width: 230px;
      margin: 0 auto;
    }
  }
  &-description{
    line-height: 1.625;
    padding-bottom: 35px;
    border-bottom: 1px solid $color-line;
    margin-bottom: 35px;
  }
}
.txt + .purchase-subtitle{
  margin-top: 30px;
  padding-bottom: 35px;
}
</style>
